import { SinglePageBaseModel } from "./single-page-base.model";

export class ScalesImporterModel extends SinglePageBaseModel {
  protected icon = 'cloud-upload';

  protected header = 'Importador de Baremos';
}
